import { render, staticRenderFns } from "./FieldCustomerEmail.vue?vue&type=template&id=3c24b554&"
import script from "./FieldCustomerEmail.vue?vue&type=script&lang=js&"
export * from "./FieldCustomerEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports